import React from 'react';
import Icon from '../../../components/AppIcon';

const MaintenanceScheduleCard = ({ schedules }) => {
  const getStatusColor = (status) => {
    const colors = {
      'Terjadwal': 'text-primary bg-primary/10',
      'Mendesak': 'text-error bg-error/10',
      'Selesai': 'text-success bg-success/10',
      'Tertunda': 'text-warning bg-warning/10'
    };
    return colors?.[status] || 'text-muted-foreground bg-muted';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'Terjadwal': 'Calendar',
      'Mendesak': 'AlertCircle',
      'Selesai': 'CheckCircle2',
      'Tertunda': 'Clock'
    };
    return icons?.[status] || 'Calendar';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Wrench" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Jadwal Pemeliharaan</h3>
      </div>
      <div className="space-y-4">
        {schedules?.map((schedule) => (
          <div key={schedule?.id} className="bg-muted/30 rounded-xl p-4 hover:bg-muted/50 transition-colors">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-card flex items-center justify-center flex-shrink-0 border border-border">
                <Icon name={schedule?.icon} size={24} color="var(--color-primary)" />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4 mb-2">
                  <div>
                    <h4 className="text-base font-semibold text-foreground mb-1">{schedule?.equipment}</h4>
                    <p className="text-sm text-muted-foreground">{schedule?.maintenanceType}</p>
                  </div>
                  <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-medium whitespace-nowrap ${getStatusColor(schedule?.status)}`}>
                    <Icon name={getStatusIcon(schedule?.status)} size={12} />
                    {schedule?.status}
                  </span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
                  <div className="flex items-center gap-2">
                    <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
                    <div>
                      <p className="text-xs text-muted-foreground">Tanggal</p>
                      <p className="text-sm font-medium text-foreground">{schedule?.scheduledDate}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <Icon name="User" size={16} color="var(--color-muted-foreground)" />
                    <div>
                      <p className="text-xs text-muted-foreground">Teknisi</p>
                      <p className="text-sm font-medium text-foreground">{schedule?.technician}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <Icon name="DollarSign" size={16} color="var(--color-muted-foreground)" />
                    <div>
                      <p className="text-xs text-muted-foreground">Estimasi Biaya</p>
                      <p className="text-sm font-medium text-foreground data-text">
                        Rp {(schedule?.estimatedCost / 1000000)?.toFixed(1)}M
                      </p>
                    </div>
                  </div>
                </div>

                {schedule?.notes && (
                  <div className="mt-3 bg-card rounded-lg p-3 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">Catatan:</p>
                    <p className="text-sm text-foreground">{schedule?.notes}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaintenanceScheduleCard;